import axios from 'axios';

import type { TransferOrderUom } from './transfer-order-api';

const prefix = '/transferOrder';

export type TransferOrderReceiveDetails = {
  transferOrderProductId: number;
  inventoryLocationId: number;
  lot: string | null;
  receivedQuantity: number | null;
  rejectedQuantity: number | null;
  productId: number;
  sku: string;
  name: string;
  orderedQuantity: number;
  cost: number;
  productUoMId?: number | null;
  orderedQuantityInUom?: number | null;
  unitsOfMeasure?: TransferOrderUom[] | null;
};

export type TransferOrderProductReceive = {
  transferOrderProductId: number;
  inventoryLocationId: number;
  receivedQuantity: number;
  rejectedQuantity: number;
  cost: number;
  productUoMId?: number | null;
  receivedQuantityInUom?: number | null;
  rejectedQuantityInUom?: number | null;
};

export type TransferOrderReceiveBody = {
  productReceives: TransferOrderProductReceive[];
};

export const getTransferOrderReceives = async (transferOrderId: number): Promise<TransferOrderReceiveDetails[]> => {
  const response = await axios.get<TransferOrderReceiveDetails[]>(`${prefix}/${transferOrderId}/receives`);
  return response.data;
};

export const postTransferOrderReceives = async (transferOrderId: number, body: TransferOrderReceiveBody): Promise<boolean> => {
  const response = await axios.post(`${prefix}/${transferOrderId}/receives`, body);
  return response.status === 200;
};
